import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "weight-value",
  templateUrl: "./weight-value.component.html",
})
export class WeightValueComponent implements OnInit {
  @Input() weight: number | string;
  @Input() textRight: boolean;
  constructor() {}

  ngOnInit() {}
}
